import {Product as ProductType} from 'coreStore/data/products/types';
import {ExpressPaymentButtonSection} from 'coreStore/data/basket/types';
import {EAddToCartType} from 'coreStore/data/ui/types';

export enum PayPalButtonStyleLabel {
	PAYPAL = 'paypal',
	CHECKOUT = 'checkout',
	BUYNOW = 'buynow',
	PAY = 'pay',
}

export enum PayPalButtonStyleColor {
	GOLD = 'gold',
	BLUE = 'blue',
	SILVER = 'silver',
	WHITE = 'white',
	BLACK = 'black',
}

export enum PayPalButtonStyleShape {
	RECT = 'rect',
	PILL = 'pill',
}

export enum PayPalButtonStyleHeight {
	HEIGHT = 50,
}

export enum PayPalButtonStyleSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
	RESPONSIVE = 'responsive',
}

export interface PayPalButtonStyle {
	size: PayPalButtonStyleSize;
	shape: PayPalButtonStyleShape;
	color: PayPalButtonStyleColor;
	tagline?: boolean;
	label: PayPalButtonStyleLabel;
	height: PayPalButtonStyleHeight;
}

export interface IPayPalButtonProps {
	className?: string;
	buttonStyle?: PayPalButtonStyle;
	product?: ProductType;
	onClick: (buttonType: EAddToCartType) => void;
	section: ExpressPaymentButtonSection;
	overridePayPalButtonStyles?: IOverridePayPalButtonStyles;
}

export interface IOverridePayPalButtonStyles extends Partial<PayPalButtonStyle> {
	height?: number;
}
